import { useClientPortalAPI } from "@certn/api";
import { useState } from "react";

import { useUser } from "./useUser";
import { useGroupSelection } from "../components/select-package-modal/useGroupSelection";

export function useApplyLink(onCreateApplyLink?: () => void) {
  const [isBillingDetailsModalOpen, setIsBillingDetailsModalOpen] =
    useState(false);
  const { details } = useUser();
  const isSSBUser = details?.client_account?.source === "SSB_SIGN_UP";
  const { data: groups } = useClientPortalAPI(
    "/api/internal/client-portal/customer-accounts/customer-groups/"
  );
  const { selectedGroup } = useGroupSelection(groups);
  const { data } = useClientPortalAPI(
    selectedGroup
      ? `/api/internal/client-portal/customer-groups/${selectedGroup}/`
      : null
  );
  const onPressCreateApplyLink = () => {
    if (!isSSBUser || (isSSBUser && data?.has_valid_billing_profile)) {
      onCreateApplyLink?.();
    } else {
      setIsBillingDetailsModalOpen(true);
    }
  };

  return {
    billingProfileId: data?.billing_profile?.id,
    isBillingDetailsModalOpen,
    hasValidBillingProfile:
      data?.has_valid_billing_profile &&
      data?.has_valid_payment_method_or_not_required,
    setIsBillingDetailsModalOpen,
    onPressCreateApplyLink,
  };
}
